import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import * as moment from 'moment';
import {isNullOrUndefined} from "util";

declare var $: any;

@Component({
  selector: 'datePicker',
  template: `
    <div class="ui icon input">
      <input type="text" class="dateRange" readonly="readonly" [attr.value]="dateValue"
             (onChange)="onChangeDate($event)">
      <i class="calendar icon"></i>
    </div>
  `,
  styles: []
})

export class DatePickerComponent implements AfterViewInit {

  @Input() public id: string;
  @Input() public name: string;
  @Input() public dateFrom: string;
  @Input() public dateTo: string;
  @Input() public direction: string = 'right';
  @Output() public datePicked: EventEmitter<any> = new EventEmitter();

  get dateValue(): string {
    // moment(new Date(date)) is used to avoid the moment deprecation warning when using non RFC2822/ISO formatted dates (e.g. 01 Aug 2017)
    // https://github.com/moment/moment/issues/1407
    return ((this.dateFrom) && (this.dateTo)) ?
      (`${moment(new Date(this.dateFrom)).format('DD MMM YYYY')} to ${moment(new Date(this.dateTo)).format('DD MMM YYYY')}`)
      : '';
  }

  public ngAfterViewInit() {
    // console.log('this.name:::', `${this.name}`);
    // console.log('this.id:::', `${this.id}`);
    // console.log('this.fromDate:::', this.dateFrom);
    // console.log('this.toDate:::', this.dateTo);
    // console.log('this:::', this);
    /* istanbul ignore next: no easy way to test JQuery */
    $(`#${this.id}`).daterangepicker({
      format: 'DD MMM YYYY',
      startDate: moment(new Date(this.dateFrom)),
      endDate: moment(new Date(this.dateTo)),
      opens: this.direction,
      singleDatePicker: false,
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')],
        'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter')],
      },
    }).on('apply.daterangepicker', (ev, picker) => {
      this.dateFrom = picker.startDate;
      this.dateTo = picker.endDate;
      // console.log("inside apply daterangepicker", this.dateFrom, this.dateTo);
      this.datePicked.emit({dateFrom: moment(picker.startDate).valueOf(), dateTo: moment(picker.endDate).valueOf()});
    }).on("show.daterangepicker", (ev, picker) => {
      // console.log("inside show daterangepicker", this.dateFrom, this.dateTo);
      const showDateFrom = this.dateFrom || moment().format('DD MMM YYYY'); // Default to now if null
      const showDateTo = this.dateTo || moment().format('DD MMM YYYY'); // Default to now if null

      $(`#${this.id}`).data('daterangepicker').setOptions({
        format: 'DD MMM YYYY',
        startDate: moment(new Date(showDateFrom)),
        endDate: moment(new Date(showDateTo)),
        opens: this.direction,
        singleDatePicker: false,
        ranges: {
        Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')],
          'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter')],
      },
    });
    });
  }

  public onChangeDate(event) {
  }
}




// WEBPACK FOOTER //
// ./client/app/shared/reportControls/date-picker-component.ts